











































































































import { formatCurrency, formatEmptyString } from "@core/filters";
import { getLogoPath } from "@/stores/webmaster/finance/modal/helpers/paymentSystemsLogo";
import ColoredStatus from "@/components/Common/ColoredStatus.vue";
import { defineEmits, defineProps, withDefaults } from "@vue/runtime-dom";
import { computed } from "@vue/composition-api";
import { Requisite } from "@core/store/types/webmaster/finances/modal/financeRequisites";
import lightning from "@/assets/common/lightning.svg";
import InlineSvg from "vue-inline-svg";
interface Props {
  item: Requisite;
  loading?: boolean;
  boundary?: string;
  value?: string | null;
  disabled?: boolean;
  hasStatus?: boolean;
  disabledTooltip?: string;
}
const __sfc_main = {};
__sfc_main.props = {
  item: {
    key: "item",
    required: true,
    type: null
  },
  loading: {
    key: "loading",
    required: false,
    type: Boolean,
    default: false
  },
  boundary: {
    key: "boundary",
    required: false,
    type: String,
    default: "scrollParent"
  },
  value: {
    key: "value",
    required: false,
    type: [String, null],
    default: null
  },
  disabled: {
    key: "disabled",
    required: false,
    type: Boolean,
    default: false
  },
  hasStatus: {
    key: "hasStatus",
    required: false,
    type: Boolean,
    default: false
  },
  disabledTooltip: {
    key: "disabledTooltip",
    required: false,
    type: String,
    default: ""
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const statusesRequisites = computed(() => {
    return {
      CREATED: "is-info",
      WAITING_FOR_APPROVE: "is-warning",
      APPROVED: "is-success",
      DENIED: "is-danger"
    };
  });
  return {
    formatCurrency,
    formatEmptyString,
    getLogoPath,
    lightning,
    emit,
    statusesRequisites
  };
};
__sfc_main.components = Object.assign({
  ColoredStatus,
  InlineSvg
}, __sfc_main.components);
export default __sfc_main;
